import { Component } from '@angular/core';

@Component({
  selector: 'app-item-sales-summary',
  standalone: false,
  
  templateUrl: './item-sales-summary.component.html',
  styles: ``
})
export class ItemSalesSummaryComponent {

}
